import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { API_BASE } from '../lib/api'
import { Logo } from '../components/Logo'
import '../styles/public-roadmap.css'

type State = 'loading' | 'success' | 'error'

export default function ConfirmIdeaPage() {
    const { token } = useParams<{ token: string }>()
    const [state, setState] = useState<State>('loading')
    const [message, setMessage] = useState('')
    const [ideaTitle, setIdeaTitle] = useState('')

    useEffect(() => {
        if (!token) { setState('error'); setMessage('Invalid confirmation link.'); return }

        fetch(`${API_BASE}/api/roadmap/confirm/${token}`)
            .then(async res => {
                const json = await res.json().catch(() => ({}))
                if (res.ok) {
                    setState('success')
                    setMessage(json.message ?? 'Confirmed!')
                    setIdeaTitle(json.title ?? '')
                } else {
                    setState('error')
                    setMessage(json.error ?? 'This link is invalid or has expired.')
                }
            })
            .catch(() => {
                setState('error')
                setMessage('Could not reach the server. Please try again later.')
            })
    }, [token])

    return (
        <div className="public-roadmap-root">
            <header className="public-roadmap-header">
                <div className="public-roadmap-header-inner">
                    <div className="public-roadmap-brand">
                        <Logo height={24} />
                        <span className="public-roadmap-subtitle">Product Roadmap</span>
                    </div>
                    <div className="public-roadmap-header-actions">
                        <Link to="/roadmap" className="btn btn-secondary">← View roadmap</Link>
                    </div>
                </div>
            </header>

            <main className="public-roadmap-content">
                <div className="confirm-card">
                    {state === 'loading' && (
                        <>
                            <div className="confirm-icon"><div className="spinner" /></div>
                            <h2>Confirming your submission…</h2>
                            <p>Just a moment.</p>
                        </>
                    )}

                    {state === 'success' && (
                        <>
                            <div className="confirm-icon confirm-icon--success">✅</div>
                            <h2>Idea confirmed!</h2>
                            {ideaTitle && <div className="confirm-idea-title">"{ideaTitle}"</div>}
                            <p>{message}</p>
                            <Link to="/roadmap" className="btn btn-primary" style={{ marginTop: 'var(--space-5)' }}>
                                View the roadmap
                            </Link>
                        </>
                    )}

                    {state === 'error' && (
                        <>
                            <div className="confirm-icon confirm-icon--error">⚠️</div>
                            <h2>Link invalid or expired</h2>
                            <p>{message}</p>
                            <div style={{ display: 'flex', gap: 'var(--space-3)', marginTop: 'var(--space-5)' }}>
                                <Link to="/roadmap" className="btn btn-primary">Submit again</Link>
                                <Link to="/login" className="btn btn-secondary">Sign in instead</Link>
                            </div>
                        </>
                    )}
                </div>
            </main>
        </div>
    )
}
